<template>
	<div>
		<component :is="ExhibitDetail.uuid ? 'heads1' : 'heads2'" :showPcShenming="showPcShenming" :headOpacity="headOpacity"></component>
	</div>
</template>

<script>
import { mapState } from "vuex";
import heads1 from './heads1.vue'
import heads2 from './heads2.vue'
export default {
	props: {
		showPcShenming: {
			type: Boolean,
			default: false
		},
		headOpacity: {
			type: Number,
			default: 1
		}
	},
	name: 'heads',
	data() {
		return {

		}
	},
	components: { heads1, heads2 },
	computed: {
		...mapState({
			ExhibitDetail: state => state.ExhibitDetail
		})
	},
	created() {

	}
}
</script>

<style lang="less"></style>


// WEBPACK FOOTER //
// src/components/heads.vue